import type { StickerIllustrationProps } from '../Sticker';

export const BookStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.3892 3.4616L61.6372 3.40223C64.1978 2.85333 66.7665 4.40378 67.4519 6.96191L84.0482 68.9C84.7557 71.5406 83.1885 74.2552 80.5479 74.9627L39.2555 86.027C30.9137 88.2619 22.3394 83.311 20.1042 74.9692L9.03999 33.6768C6.8051 25.3352 11.7553 16.7612 20.0968 14.5259L61.3892 3.4616Z"
      fill="#FADD99"
      stroke="white"
      strokeWidth="5.625"
      strokeLinejoin="round"
    />
    <mask id="path-2-inside-1_9413_149" fill="white">
      <path d="M11.7568 32.9493C9.92358 26.1078 13.9836 19.0756 20.8252 17.2424L62.1174 6.1782C63.2576 5.87267 64.4297 6.54934 64.7352 7.6896L81.3315 69.6279C81.637 70.7682 80.9604 71.9402 79.8201 72.2457L38.5279 83.3099C31.6864 85.1431 24.6542 81.0831 22.821 74.2415L11.7568 32.9493Z" />
    </mask>
    <path
      d="M11.7568 32.9493C9.92358 26.1078 13.9836 19.0756 20.8252 17.2424L62.1174 6.1782C63.2576 5.87267 64.4297 6.54934 64.7352 7.6896L81.3315 69.6279C81.637 70.7682 80.9604 71.9402 79.8201 72.2457L38.5279 83.3099C31.6864 85.1431 24.6542 81.0831 22.821 74.2415L11.7568 32.9493Z"
      fill="#FADD99"
      stroke="#005E86"
      strokeWidth="8.54977"
      strokeLinejoin="round"
      mask="url(#path-2-inside-1_9413_149)"
    />
    <path
      d="M24.8854 73.6884C21.5561 61.2631 13.6484 31.751 13.6484 31.751C12.2162 26.406 15.2697 20.9438 21.3782 19.3071L62.6704 8.24285L73.9075 50.1803C73.9075 50.1803 42.9985 58.4623 33.3527 61.0469C27.2695 62.6769 23.4524 68.3401 24.8854 73.6884Z"
      fill="#99C8DC"
      stroke="#005E86"
      strokeWidth="4.27488"
      strokeLinejoin="round"
    />
    <path
      d="M45.7339 64.7828L66.38 59.2507"
      stroke="#F5BA33"
      strokeWidth="4.27488"
      strokeLinecap="round"
    />
    <path
      d="M38.3796 74.4983L59.0257 68.9662"
      stroke="#F5BA33"
      strokeWidth="4.27488"
      strokeLinecap="round"
    />
    <rect
      x="30.3384"
      y="27.9705"
      width="21.3744"
      height="8.54977"
      rx="4.27488"
      transform="rotate(-15 30.3384 27.9705)"
      fill="#005E86"
    />
  </svg>
);
